import LogoImg from '../../../public/img/logo-picsize-freemium.png'
import './FreemiumBar.scss'

export default function FreemiumBar() {

    return (
        <div className='ps-sf-freemium-bar'>
            <div className='picsize-logo' style={{ backgroundImage: `url(${LogoImg})` }}></div>
            <div className='bar-text'>
                Galeria criada com <i className='fa fa-heart-o'></i> pela Picsize
            </div>
        </div>
    )

}
